import React from 'react'

import Nav from '../Nav/Nav'
import Position from '../Position/Position'

import './PositionScene.css'
import positionSceneContainer from './positionSceneContainer'

class PositionScene extends React.Component {
  componentDidMount() {
    this.props.loadPosition()
  }

  render() {
    return (
      <div className="PositionScene">
        <Nav slim={true} />
        <div className="container">
          <Position runButtonVisible={false} standalone={true} />
        </div>
      </div>
    )
  }
}

export default positionSceneContainer(PositionScene)



// WEBPACK FOOTER //
// ./src/components/PositionScene/PositionScene.js